module.exports = __webpack_public_path__ + "static/media/form-header-range.686e595f.svg";